// extracted by mini-css-extract-plugin
export var colorSquare = "_tp-0";
export var danger = "_tp-5";
export var lightPink = "_tp-8";
export var neutralBlue = "_tp-7";
export var neutralYellow = "_tp-6";
export var normal = "_tp-1";
export var primary = "_tp-2";
export var primaryLight = "_tp-3";
export var solidBlack = "_tp-g";
export var solidGreen = "_tp-b";
export var solidLightBlue = "_tp-d";
export var solidNavy = "_tp-c";
export var solidOrange = "_tp-f";
export var solidPink = "_tp-e";
export var solidRed = "_tp-9";
export var solidYellow = "_tp-a";
export var success = "_tp-4";